import React, { Component } from "react";
import styled from "styled-components";
import { RollFromLeft } from "../ui/animations";
import { Formik } from "formik";
import * as Yup from "yup";
// import { RollFromLeft } from "../ui/animations/";

const ContactSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, "First Name too short")
    .max(50, "First Name too long")
    .required("First Name is required"),
  lastName: Yup.string()
    .min(2, "Last Name too short")
    .max(50, "Last Name too long")
    .required("Last Name is required"),
  website: Yup.string()
    .min(2, "Website too short")
    .max(50, "Website too long")
    .required("Website is required"),
  email: Yup.string()
    .email("Invalid Email")
    .required("Email is required"),
  message: Yup.string()
    .min(10, "Message too short")
    .required("Message is required")
});

const ContactContainer = styled.div`
  background: #0b0b0b;
  box-shadow: 0px 4px 76px rgba(0, 0, 0, 0.5);
  z-index: 30;
  animation: ${RollFromLeft} 1.75s ease;
  .form--wrapper {
    display: flex;
    padding: 100px 55px 40px;
    flex-direction: row;
    @media (max-width: 800px) {
      flex-direction: column;
    }
    @media (max-width: 600px) {
      padding: 50px 20px 20px;
    }
    .form--row {
      display: flex;
      flex-direction: column;
      flex: 1;
      &:first-child {
        padding-right: 40px;
        @media (max-width: 800px) {
          padding-right: 0;
        }
      }
      input {
        margin-bottom: 90px;
        width: 400px;
        /* min-width: 200px; */
        background-color: #0b0b0b;
        border: 1px solid rgba(255, 255, 255, 0.5);
        padding: 15px;
        color: rgba(255, 255, 255, 0.5);
        outline: none;
        &:last-child {
          margin-bottom: 0;
          @media (max-width: 800px) {
            margin-bottom: 50px;
          }
        }
        &:focus {
          background-color: #141414;
        }
        &:hover {
          background-color: #101010;
        }
        /* @media (max-width: 1600px) {
          width: auto;
        } */
        @media (max-width: 1400px) {
          width: auto;
          margin-bottom: 50px;
        }
      }
      textarea {
        margin-bottom: 90px;
        width: 400px;
        background-color: #0b0b0b;
        border: 1px solid rgba(255, 255, 255, 0.5);
        padding: 15px;
        color: rgba(255, 255, 255, 0.5);
        outline: none;
        resize: none;
        margin-bottom: 45px;
        height: 159px;
        &:focus {
          background-color: #141414;
        }
        &:hover {
          background-color: #101010;
        }
        @media (max-width: 1600px) {
          width: auto;
        }
        @media (max-width: 1400px) {
          width: auto;
          height: 129px;
        }
      }

      button {
        width: 177px;
        height: 48px;
        background-color: #0b0b0b;
        border: 1px solid #fff;
        color: #fff;
        outline: none;
        margin-bottom: 0;
        font-family: "Fira Sans";
        font-size: 20px;
        align-self: flex-end;
        @media (max-width: 600px) {
          width: 100%;
        }
        &:hover {
          cursor: pointer;
          color: #0b0b0b;
          border-color: #0b0b0b;
          background-color: #fff;
        }
      }
      p {
        font-size: 14px;
        margin-top: -80px;
        margin-bottom: 64px;
        color: red;
      }
      p.area {
        margin-top: -36px;
        margin-bottom: 20px;
      }
    }
  }
`;

const ResposeMessage = styled.span`
  margin: 8px 55px 35px 35px;
  display: block;
  color: ${p => p.error ? "red" : "white" };
`;

class ContactBox extends Component {
  constructor(props) {
    super();
    this.state = {
      response: '',  // not sure what server returns as a message so I wont use this
      responseMessage: '',
      responseError: false,
    }
  }

  render() {
    return (
      <ContactContainer>
        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            website: "",
            email: "",
            message: ""
          }}
          validationSchema={ContactSchema}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            try {
              setSubmitting(true);
              let response = await fetch(
                "https://mailer.uon.rs/send",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                    hostname: "uon.rs",
                    fullName: values.firstName + " " + values.lastName,
                    email: values.email,
                    website: values.website,
                    message: values.message
                  })
                }
              );
              let data = await response.json();
              this.setState({
                response: data.message,
                responseError: false,
                responseMessage: 'Thank you for contacting us. We will respond to you soon.'
              });
              resetForm();
              setSubmitting(false);
            } catch (err) {
              this.setState({
                response: err,
                responseError: true,
                responseMessage: 'There was an error while sending your message. Please contact us via email or phone.'
              });
              setSubmitting(false);
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting
          }) => {
            return (
              <form className="contact--form">
                <div className="form--wrapper">
                  <div className="form--row">
                    <input
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      value={values.firstName}
                      onChange={handleChange}
                      autoComplete="off"
                    />
                    {/* Error handling for first name: */}
                    {touched.firstName && errors.firstName ? (
                      <p>{errors.firstName}</p>
                    ) : null}
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      value={values.lsatName}
                      onChange={handleChange}
                      autoComplete="off"
                    />
                    {/* Error handling for last name: */}
                    {touched.lastName && errors.lastName ? (
                      <p>{errors.lastName}</p>
                    ) : null}
                    <input
                      type="text"
                      name="email"
                      placeholder="Email"
                      value={values.email}
                      onChange={handleChange}
                      autoComplete="off"
                    />
                    {/* Error handling for email: */}
                    {touched.email && errors.email ? (
                      <p>{errors.email}</p>
                    ) : null}
                  </div>
                  <div className="form--row">
                    <input
                      type="text"
                      name="website"
                      placeholder="Website"
                      value={values.website}
                      onChange={handleChange}
                      autoComplete="off"
                    />
                    {/* Error handling for website: */}
                    {touched.website && errors.website ? (
                      <p>{errors.website}</p>
                    ) : null}
                    <textarea
                      name="message"
                      placeholder="Message"
                      value={values.message}
                      onChange={handleChange}
                    />
                    {/* Error handling for message: */}
                    {touched.message && errors.message ? (
                      <p className="area">{errors.message}</p>
                    ) : null}

                    <button onClick={handleSubmit} type="button">
                      SEND
                    </button>
                  </div>
                </div>
                {/* <Button
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                  colorClass="red"
                  text="Pošalji"
                /> */}
              </form>
            );
          }}
        </Formik>
        <ResposeMessage
          success={this.state.error}
        >{this.state.responseMessage}</ResposeMessage>
      </ContactContainer>
    );
  }
}

export default ContactBox;
